module.exports = __webpack_public_path__ + "static/media/Screenshot 2023-01-24 at 9_1674558734516.71ab2867.05";